import React from "react";
import GradientCard from "../gradients/GradientCard";
import { Box, Typography } from "@mui/material";

const ViewCard = ({ view, thumbnail, children, select, openMobileView }) => {
  return (
    <Box sx={{ width: "90px", paddingTop: "12px" }} onClick={select}>
      <Typography
        align="center"
        variant="h4"
        sx={{
          textTransform: "capitalize",
          color: openMobileView ? "#ffffff" : "",
          fontSize: "13px",

          margin: "0",
        }}
      >
        {view + " view"}
      </Typography>
      <GradientCard
        variant="square"
        selected={false}
        sxMobile={{
          border: "none",
          borderRadius: "9px",
        }}
        sxInnerMobile={{
          borderRadius: "9px",
        }}
      >
        <Box
          sx={{
            flex: "1",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={thumbnail}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </Box>
      </GradientCard>
      {children}
    </Box>
  );
};

const ViewToolbar = ({
  canvasImage,
  variants,
  handleToolbarChange,
  setMobileView,
  openMobileView,
}) => {
  if (!canvasImage) {
    return null;
  }

  const isOneVariant = variants.length > 1;

  const handleSelect = ({ view }) => {
    isOneVariant && setMobileView((prevState) => !prevState);
    if (view !== canvasImage.view) {
      view && handleToolbarChange(view);
    }
  };

  return openMobileView && isOneVariant ? (
    variants.map((variant, i) => (
      <React.Fragment key={String(i)}>
        <ViewCard
          view={variant.view}
          thumbnail={variant.thumbnail}
          select={handleSelect.bind(null, variant)}
          openMobileView={openMobileView}
        />
      </React.Fragment>
    ))
  ) : (
    <ViewCard view={canvasImage.view} thumbnail={canvasImage.thumbnail} select={handleSelect}>
      {isOneVariant && (
        <Typography
          align="center"
          variant="body2"
          sx={{
            fontSize: "14px",
            marginTop: "8px",
          }}
        >
          Select
        </Typography>
      )}
    </ViewCard>
  );
};

export default React.memo(ViewToolbar);
